import { Container } from './Loader.styles';

export const Loader = () => (
  <Container>
    <div />
    <div />
    <div />
    <div />
  </Container>
);
